import { useQuery } from "@tanstack/react-query";
import { getOfferAvatarsFreshness } from "@/app/actions/client-avatar/get/action";
import { Globals } from "@/app/vars/Globals";
import { AvatarQuerySubKey, QueryKey } from "@/app/vars/QueryKeys";

export function useFetchOfferAvatarsFreshness(
  options: { offerId?: number; enabled?: boolean } = {},
) {
  const { offerId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.CLIENT_AVATAR, AvatarQuerySubKey.FRESHNESS, offerId],
    queryFn: () => getOfferAvatarsFreshness(offerId!),
    enabled: enabled && !!offerId,
    staleTime: Globals.AVATAR_FRESHNESS_STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });
}
